import "./index.css"
import { useParams } from "react-router";
import { useState, useEffect} from "react";
import blogData from "../../Database/blog_business_posts.json";
import parse from 'html-react-parser'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.css"
import MetaTags from "../../../components/MetaTags";

export default function Posts(){
    const BlogDataArray = blogData.BlogBusinessData
    const { bid } = useParams();
    // console.log(bid)
    const blog = BlogDataArray.find((blog) => blog._id === bid)
    let text_blog:string;
    text_blog = blog?._full_content ?? '';
    const moment = require('moment');
    const [isThereLinkedInPost, setisThereLinkedInPost] =useState(blog?._is_linkedin_link_post);
    const [isUniqueImg, setisUniqueImg] = useState(blog?._is_img_unique);
    const ImgsInfoArray = blog?._carousel_data;
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 750);
        };

        handleResize(); // Initial check
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);

    }, []);

    function limitText(text:string, maxLength:number) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength);
      }
      return text;
    }
    let text_blog_seo:string;
    text_blog_seo = blog?._small_description_seo ?? '';
    let small_description_seo = limitText(text_blog_seo, 170);

    return(
      <>
      <MetaTags 
        title={blog?._title}
        description={small_description_seo}
        image={blog?._principal_img} />
        <div id="wd-blog-post" className="pt-0 pb-3 me-4">
            <div className="row">
                <div className="col-md-1 col-lg-2"></div>
                <div className="col-12 col-md-10 col-lg-8">
                    <h1 className="wd-blog-title"> {blog?._title}</h1> <hr/>
                    { isThereLinkedInPost ? (
                    <div id="wd-authored-row" className="row">
                        <div className="col-sm-4">
                            <div className="ms-0" id="wd-author-by">AUTHORED BY</div>
                            <div className="ms-0" id="wd-author">Alfonso Barajas</div>
                        </div>
                        <div className="col-sm-4">
                            <div className="me-0" id="wd-author-by">DATE</div>
                             <div className="me-0" >{moment(blog?._date).format('MM/DD/YYYY')}</div>
                        </div>
                        <div className="col-sm-4">
                        <div className="me-0" id="wd-author-by">Post</div>
                         <div className="me-0"> <a className="wd-github-repo" href={blog?._linkedin_link_post} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedin} size="2x"/></a></div>
                    </div>
                    </div>) : (<div id="wd-authored-row" className="row">
                        <div className="col-sm-6">
                            <div className="ms-0" id="wd-author-by">AUTHORED BY</div>
                            <div className="ms-0" id="wd-author">Alfonso Barajas</div>
                        </div>
                        <div className="col-sm-6">
                            <div className="me-0" id="wd-author-by">DATE</div>
                             <div className="me-0" >{moment(blog?._date).format('MM/DD/YYYY')}</div>
                        </div>
                        </div>

                    )
                    }
                    <div id="wd-post-content" className="pt-4 pb-2">
                    { (isUniqueImg || isMobile) ? (
                    <div id="wd-post-image">
                        <img src={blog?._principal_img} className="wd-image-home" />
                    </div>) : (
                    <div className="d-flex justify-content-center">
                    <div id="carouselExampleCaptions" className="carousel carousel-dark slide d-flex justify-content-center" data-bs-ride="carousel">
                    <div className="carousel-indicators">
                        {ImgsInfoArray?.map( (_, index) => (
                                <button  
                                key={index}
                                type="button" 
                                data-bs-target="#carouselExampleCaptions" 
                                data-bs-slide-to={index}
                                className={index === 0 ? "active" : ""}
                                aria-current={index === 0 ? "true": undefined}
                                aria-label={`Slide ${index + 1}`}>
                                </button>
                        ))}
                    </div>
                  
                    <div className="carousel-inner d-flex align-items-center center wd-image-home pb-5">

                      {ImgsInfoArray?.map( (slide,index) => (
                        <div    key={index} 
                                className={`carousel-item center ${index === 0 ? "active" : ""}`}
                                >
                        <img src={slide.image} className="d-block wd-image-home carousel-img w-100" alt={`Slide ${index+1}`} />
                        <div className="slide-caption-container">
                          <h5 className="text-black">{slide.label}</h5>
                          <p className="text-black">{slide.description}</p>
                        </div>
                      </div>

                      ))}
                

                    </div>
                  
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                      <span className="carousel-control-next-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Next</span>
                    </button>
                  </div>

                  </div>
                    )
                    }

                    <br/>
                    <div id="wd-post-text"  className="text-start">
                    {parse(text_blog)}
                    </div>
                    </div>
                </div>
                <div className="col-md-1 col-lg-2"></div>
            </div>
        </div>
      </>
    );
}